import { DataCurrencyDisplay, DataCurrencyLayout, DataCurrencyNegativeDisplay, DataCurrencySign, DataDateFormat, DataDisplayOptions as DataDisplayOptionsDto, DataNumberFormat, DataTimeFormat, LiteralType, NumberRoundingMethod } from 'src/app/services/api.services';
import { DataQueryExpr } from '../dataQuery';

export type DataDisplayOptions = DataDisplayOptionsDto;

export namespace DataDisplayOptions {
  export const defaultStrings = {
    TRUE: '#TRUE',
    FALSE: '#FALSE',

    NAN: '#NUM!',

    INF_POSITIVE: '#INFINITY',
    INF_NEGATIVE: '#-INFINITY',

    ERROR: '#ERROR!',
    NULL: '#NULL',
  };

  export const defaults: DataDisplayOptions = {
    numberFormat: DataNumberFormat.Default,
    numberRounding: null,

    showThousandSeparator: true,
    currency: {
      sign: DataCurrencySign.Sign,
      layout: DataCurrencyLayout.Accounting,
      negativeDisplay: DataCurrencyNegativeDisplay.WithValue
    },

    naNText: defaultStrings.NAN,
    positiveInfinityText: defaultStrings.INF_POSITIVE,
    negativeInfinityText: defaultStrings.INF_NEGATIVE,

    timeFormat: DataTimeFormat.Full,
    dateFormat: DataDateFormat.Short,
    forceTwentyFourClock: false,

    trueQueryExpr: DataQueryExpr.createStringLiteralSyntaxTree(defaultStrings.TRUE),
    falseQueryExpr: DataQueryExpr.createStringLiteralSyntaxTree(defaultStrings.FALSE),

    errorQueryExpr: DataQueryExpr.createStringLiteralSyntaxTree(defaultStrings.ERROR),
    nullQueryExpr: DataQueryExpr.createStringLiteralSyntaxTree(defaultStrings.NULL),
    numericAggregationNullQueryExpr: DataQueryExpr.createLiteralSyntaxTree(LiteralType.Integer, 0),

    formattingQueryExpr: null
  };

  export const countOfDefault: DataDisplayOptions = {
    ...defaults,
    numberRounding: {
      method: NumberRoundingMethod.Ceil,
      precision: 0
    }
  };
}

